const resetPersistent = whitelistTarget => ({ type: `@@${whitelistTarget}/reset` })

export default resetPersistent
